var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgE2Ee = function SvgE2Ee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.75 7.5h10.5V15H3.75zM14.25 6h-1.5v-.75a3.75 3.75 0 1 0-7.5 0V6h-1.5a1.5 1.5 0 0 0-1.5 1.5V15a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5V7.5a1.5 1.5 0 0 0-1.5-1.5m-4.524 5.813a1.5 1.5 0 1 0-1.452 0A.8.8 0 0 0 8.25 12v.75a.75.75 0 0 0 1.5 0V12a.8.8 0 0 0-.024-.187M9 3a2.25 2.25 0 0 1 2.25 2.25V6h-4.5v-.75A2.25 2.25 0 0 1 9 3",
    clipRule: "evenodd"
  })));
};
export default SvgE2Ee;